import { render, staticRenderFns } from "./SendReminder.vue?vue&type=template&id=00e117a1&scoped=true&"
import script from "./SendReminder.vue?vue&type=script&lang=js&"
export * from "./SendReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e117a1",
  null
  
)

export default component.exports